import * as fromSetings from '../reducers/settingsReducers'

export const isSideNavCollapsed = state => fromSetings.isSideNavCollapsed(state.settings)
export const isSideNavExpanded = state => fromSetings.isSideNavExpanded(state.settings)
export const pageTitle = state => fromSetings.pageTitle(state.settings)
